/**
 * RoleSelector component
 * Dropdown for selecting user roles
 */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { ROLE_OPTIONS, type RoleCode } from '@/types/admin'

export interface RoleSelectorProps {
  /** Current selected role */
  value: RoleCode
  /** Called when role selection changes */
  onChange: (role: RoleCode) => void
  /** Whether the selector is disabled */
  disabled?: boolean
  /** Additional CSS classes */
  className?: string
}

/**
 * Dropdown selector for user roles
 */
export function RoleSelector({ value, onChange, disabled, className }: RoleSelectorProps) {
  return (
    <Select value={value} onValueChange={onChange as (value: string) => void} disabled={disabled}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select a role" />
      </SelectTrigger>
      <SelectContent>
        {ROLE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
